import React from "react";
import styles from "../Reservations/styles/View.module.scss";
import { Col, Row, Card, CardBody } from "reactstrap";
import { convertDate, getDate, getDateTime, getReservationTypeLabel } from "../../helpers/functions";
import { Button } from "reactstrap";
import { useNavigate } from "react-router-dom";

export default function RefundView({ refundDetail }) {
    const navigate = useNavigate();

    const getFacility = (status) => {
        if (status === 0) return "Non Facility";
        else if (status === 1) return "Facility";
        else return "";
    };

    const getPaymentStatusLabel = (status) => {
        switch (status) {
            case '0':
                return 'Pending';
            case '1':
                return 'Paid';
            case '2':
                return 'Refund';
            case '3':
                return 'Partial Refund';
            case '4':
                return 'Dispute';
            default:
                return 'Unknown';
        }
    };

    if (!refundDetail) {
        return <div>Loading...</div>;
    }

    const reservation = refundDetail.Reservation;
    const space = reservation?.Space;
    const host = space?.User;
    const payout = refundDetail.Payout;
    const refund = refundDetail.Refunds?.[0];

    return (
        <Row>
            <Col md="12">
                <Card className="main-card mb-3">
                    <CardBody>
                        <Row className="mb-3">
                            <Col md="12" className="text-right d-flex justify-content-between align-items-center">
                                <h3>Refund Details</h3>
                                <Button color="secondary" onClick={() => navigate(-1)}>
                                    Back
                                </Button>
                            </Col>
                        </Row>

                        <Row>
                            <Col md="3">
                                <h6 className={styles.header}>Transaction Code</h6>
                                <p className={styles.subHeader}>{refundDetail?.transactionCode}</p>
                            </Col>
                            <Col md="3">
                                <h6 className={styles.header}>Payment Status</h6>
                                <p className={styles.subHeader}>{getPaymentStatusLabel(refundDetail?.paymentStatus)}</p>
                            </Col>
                            <Col md="3">
                                <h6 className={styles.header}>Payment Date</h6>
                                <p className={styles.subHeader}>{convertDate(new Date(refundDetail?.paymentDate))}</p>
                            </Col>
                            <Col md="3">
                                <h6 className={styles.header}>Currency</h6>
                                <p className={styles.subHeader}>{refundDetail?.currencyCode?.toUpperCase()}</p>
                            </Col>
                        </Row>

                        {reservation && (
                            <Row>
                                <Col md="3">
                                    <h6 className={styles.header}>Reservation Code</h6>
                                    <p className={styles.subHeader}>{reservation?.reservationCode || 'N/A'}</p>
                                </Col>
                                <Col md="3">
                                    <h6 className={styles.header}>Reservation Type</h6>
                                    <p className={styles.subHeader}>{getReservationTypeLabel(reservation?.reservationType)}</p>
                                </Col>
                            </Row>
                        )}

                        <Row>
                            <Col md="3">
                                <h6 className={styles.header}>Host</h6>
                                {host ? (
                                    <>
                                        <p className={styles.subHeader}>{host.id}</p>
                                        <p className={styles.subHeader}>{`${host.firstName} ${host.lastName}`}</p>
                                        {host.email && <p className={styles.subHeader}>{host.email}</p>}
                                        {host.phoneNumber && <p className={styles.subHeader}>{host.phoneNumber}</p>}
                                    </>
                                ) : (
                                    <p className={styles.subHeader}>N/A</p>
                                )}
                            </Col>
                            <Col md="3">
                                <h6 className={styles.header}>Space</h6>
                                {space ? (
                                    <>
                                        <p className={styles.subHeader}>{space.id}</p>
                                        <p className={styles.subHeader}>{space.title}</p>
                                        <p className={styles.subHeader}>
                                            {space.addressOne && space.addressOne}
                                            {space.addressTwo && ", " + space.addressTwo} <br />
                                            {space.city && space.city}
                                            {space.stateCode && ", " + space.stateCode}
                                            {space.zipCode && ", " + space.zipCode}
                                        </p>
                                        <p className={styles.subHeader}>
                                            {getFacility(space.facility)}
                                        </p>
                                    </>
                                ) : (
                                    <p className={styles.subHeader}>N/A</p>
                                )}
                            </Col>
                        </Row>

                        <Row>
                            <Col md="12">
                                <h6 className={styles.header}>Transaction Financial Breakdown</h6>
                                <p className={styles.subHeader}> Rate: ${refundDetail?.rate} </p>
                                <p className={styles.subHeader}> Renter Service Fee %: {refundDetail?.renterServiceFeePercent || '0.00'} </p>
                                <p className={styles.subHeader}> Service Fee: ${refundDetail?.serviceFee} </p>
                                <p className={styles.subHeader}> Fixed Fee: ${refundDetail?.fixedFee} </p>
                                <p className={styles.subHeader}> Sales Tax: ${refundDetail?.salesTax} </p>
                                <p className={styles.subHeader}> Discount Amount: ${refundDetail?.discountAmount} </p>
                                <p className={styles.subHeader}> Gross Amount: ${refundDetail?.grossAmount} </p>
                                <hr />
                                <h6 className={styles.header}><strong>Net Amount: ${refundDetail?.netAmount}</strong></h6>
                            </Col>
                        </Row>

                        {refund && (
                            <Row className="mt-3">
                                <Col md="12">
                                    <h6 className={styles.header}>Refund Information</h6>
                                    <p className={styles.subHeader}> Refund Amount: ${refund?.refundAmount} </p>
                                    <p className={styles.subHeader}> Refund Type: {refund?.refundType || 'full'} </p>
                                    <p className={styles.subHeader}> Refund Reason: {refund?.refundReason || 'N/A'} </p>
                                    <p className={styles.subHeader}> Refund Notes: {refund?.refundNotes || 'N/A'} </p>
                                    <p className={styles.subHeader}> Refund Date: {convertDate(new Date(refund?.createdAt))} </p>
                                </Col>
                            </Row>
                        )}

                        {payout && (
                            <Row className="mt-3">
                                <Col md="12">
                                    <h6 className={styles.header}>Payout Information</h6>
                                    <p className={styles.subHeader}> Payout Transaction Code: {payout?.transactionCode} </p>
                                    <p className={styles.subHeader}> Payout Type: {payout?.payoutType || 'Stripe'} </p>
                                    <p className={styles.subHeader}> Payout Amount: ${payout?.amount} </p>
                                    <p className={styles.subHeader}> Payout Status: {getPaymentStatusLabel(payout?.paymentStatus)} </p>
                                    <p className={styles.subHeader}> Payout Date: {convertDate(new Date(payout?.paymentDate))} </p>
                                </Col>
                            </Row>
                        )}
                    </CardBody>
                </Card>
            </Col>
        </Row>
    );
}
